(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Toolkit", [], factory);
	else if(typeof exports === 'object')
		exports["Toolkit"] = factory();
	else
		root["Toolkit"] = factory();
})(self, () => {
return 